export default class ItemModel {
    constructor () {

        this.title = ''
        this.owner_id = null
        this.status = 'New'      
        this.user = {}        
    }
}